export const themeOptionFactory = (theme) => ({
  components: {
    AppDetailPage: {
      styleOverrides: {
        titleText: {
          textTransform: "uppercase",
        },
        captionText: {
          color: theme.palette.secondary.main,
          fontSize: "1.25rem",
        },
        titleActionContainer: {
          "& .MuiButton-root": {
            padding: theme.spacing(1.25, 2.5),
          },
        },
        titleAction: {
          fontSize: "1rem",
        },
        stretchButton: {
          padding: theme.spacing(2, 3.75),
          "& .MuiTypography-root": {
            fontSize: "1.25rem",
          },
        },
        occupantListDetail: {
          backgroundColor: theme.palette.common.white,
          position: "absolute",
          right: "629px",
          bottom: "20px",
          width: 554,
          height: 934,
          borderRadius: "20px",
          boxShadow:
            "-45px 0 13px 0 rgba(0, 0, 0, 0.00), -29px 0 11px 0 rgba(0, 0, 0, 0.01), -16px 0 10px 0 rgba(0, 0, 0, 0.02), -7px 0 7px 0 rgba(0, 0, 0, 0.04), -2px 0 4px 0 rgba(0, 0, 0, 0.04)",
          "& .SimpleBar-container": {
            ":after": {
              content: "''",
              position: "absolute",
              zIndex: 2,
              bottom: 0,
              right: 0,
              width: "100%",
              height: "52px",
              background: `linear-gradient(0deg, ${theme.palette.common.white} 0%, rgba(255, 255, 255, 0.00) 100%)`,
            },
            "& .simplebar-vertical": {
              right: "10px",
              zIndex: 3,
              paddingTop: theme.spacing(2.5),
            },
          },
        },
        occupantListContent: {
          padding: theme.spacing(4, 4, 0, 4),
        },
        occupantLisHeader: {
          color: theme.palette.secondary.dark,
          fontWeight: 700,
        },
        list: {
          width: "100%",
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: theme.spacing(0, 3),
          margin: theme.spacing(1.5, 0, 0, 0),
          padding: 0,
          "& .MuiDivider-root": {
            margin: 0,
          },
        },
        listItem: {
          "&.FeatureListDetail-listItem": {
            padding: theme.spacing(1.5, 0),
            ".FeatureListItem-listItemAvatar": {
              minWidth: "48px",
              "& .MuiAvatar-root": {
                width: "48px",
                height: "48px",
                "& .MuiSvgIcon-root": {
                  width: "100%",
                  height: "100%",
                  padding: theme.spacing(1),
                },
              },
            },
            ".FeatureListItem-listItemContent": {
              height: "100%",
              ".MuiListItemText-root": {
                margin: 0,
              },
            },
            ".MuiListItemText-primary": {
              fontSize: "1rem",
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              whiteSpace: "pre-wrap",
              margin: 0,
            },
            ".MuiListItemText-secondary": {
              display: "none",
            },
            ".FeatureListItem-adornmentWrapper": {
              display: "none",
            },
          },
        },
      },
    },
    OccupantImageCard: {
      styleOverrides: {
        root: {
          boxShadow: theme.shadows[1],
          display: "flex",
          flexDirection: "column",
          height: 262,
          borderRadius: `${(theme.shape.borderRadius * 2) / 3}px`,
          "&.section-card": {
            border: "1px solid transparent",
            background:
              "linear-gradient(181deg, rgba(255, 250, 237, 0.44) 10.64%, rgba(217, 195, 142, 0.44) 158.34%) padding-box, linear-gradient(white, white) padding-box, linear-gradient(to right, #FFFAED, #D9C38E) border-box",
            backgroundClip: "padding-box, padding-box, border-box",
            ".OccupantImageCard-levelContainer": {
              backgroundColor: theme.palette.primary.dark,
            },
          },
        },
        header: {
          boxShadow: theme.shadows[1],
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
          "& .MuiAvatar-root": {
            borderRadius: "0",
            width: "100%",
            height: "100%",
          },
          "& .MuiAvatar-img": {
            objectFit: "contain",
          },
          "& .MuiSvgIcon-root": {
            width: 48,
            height: 48,
          },
        },
        chipContainer: {
          width: "100%",
          display: "flex",
          position: "absolute",
          padding: theme.spacing(1),
          zIndex: 1,
          top: 0,
        },
        zoneChip: {
          padding: theme.spacing(0.5, 1.5),
          height: 30,
          borderRadius: "9999px",
          border: `0.4px solid ${theme.palette.primary.dark}`,
          backgroundColor: theme.palette.common.white,
          marginRight: "auto",
          "& .MuiChip-label": {
            padding: 0,
            fontSize: "0.875rem",
            fontWeight: 400,
            color: theme.palette.primary.dark,
            textTransform: "capitalize",
          },
        },
        highlightChip: {
          padding: theme.spacing(0.5, 1),
          height: 30,
          borderRadius: "9999px",
          backgroundColor: theme.palette.primary.dark,
          marginLeft: "auto",
          "& .MuiChip-label": {
            padding: 0,
            fontSize: "0.875rem",
            fontWeight: 400,
            color: theme.palette.common.white,
            textTransform: "capitalize",
          },
        },
        headerCover: {
          width: "100%",
          height: 180,
          backgroundColor: "#BDBDBD",
        },
        contentContainer: {
          display: "flex",
          justifyContent: "space-between",
          height: "100%",
          position: "relative",
          gap: theme.spacing(2),
          padding: theme.spacing(0.5),
          "& .MuiTypography-root": {
            lineHeight: 1.25,
          },
        },
        adornmentContainer: {
          display: "flex",
          alignItems: "end",
          position: "absolute",
          bottom: 0,
          right: 0,
        },
        adornment: {
          background: "#A4A4AD",
          width: 42,
          height: 38,
          color: theme.palette.common.white,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderTopLeftRadius: "20px",
          "& .MuiTypography-root": { fontSize: "1.25rem", fontWeight: 400 },
        },
        logo: {
          display: "flex",
          gap: theme.spacing(0.5),
          "& .MuiAvatar-root": {
            width: 66,
            height: 66,
            borderRadius: "4px",
          },
        },
        icon: {
          width: 32,
          height: 32,
        },
        textContainer: {
          width: "100%",
        },
        title: {
          color: theme.palette.text.primary,
          fontSize: "1.125rem",
          fontWeight: 700,
          flex: 1,
          textTransform: "capitalize",
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 2,
          overflow: "hidden",
        },
        subtitleContainer: {
          width: "100%",
          gap: theme.spacing(2),
          ":before": {
            content: "''",
            width: "93px",
            borderTop: `1px solid ${theme.palette.divider}`,
            marginTop: "4px",
            top: 0,
          },
        },
        subtitle: {
          fontSize: "1.125rem",
          fontWeight: 400,
          color: theme.palette.text.primary,
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 1,
          overflow: "hidden",
        },
      },
    },
  },
})
